import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
// import { useNavigate } from 'react-router-dom';
import { RSVPCardData } from "../../components";
import logo from "../../assets/images/jzlogosmall.png";
import "./style.css";
import Reusablebutton from "../../components/Button/Reusablebutton";
import InputField from "../../components/TextField/InputField";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../constants/endpoints";
import { CustomToast } from "../../components/Toaster/Toaster";
import LoaderModal from "../../components/Loader/LoaderModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Dropdown from "../../components/Multiselect/Dropdown";
import newbg from "../../assets/images/newbg.png";
const events = {
  milad: {
    id: "1c3af74e-cac8-45b2-94a3-4b66520eddbe",
    content: [
      // { text: "RASHIDA", className: "mainhead " },
      // { text: "&", className: "mainhead" },
      { text: "SHEHLA GHAZANFAR", className: "mainhead" },
      {
        text: "REQUEST THE HONOR OF YOUR PRESENCE AT THE LADIES MILAD",
        className: "headingText3",
      },
      {
        text: "TO CELEBRATE THE WEDDING OF",
        className: "headingText3",
      },
      {
        text: "ZAINAB ALI",
        className: "headingText3",
      },
    ],
  },
  welcome: {
    id: "0d6160d0-ad2c-410c-b004-a769369328d8",
    content: [
      { text: "RAZA MERCHANT REQUESTS THE", className: "headingText4" },
      { text: "PLEASURE OF YOUR COMPANY AT  ", className: "headingText4" },
      { text: "GENTS WELCOME DINNER ", className: "mainhead" },
      { text: "", className: "headingText2" },
    ],
    //dressCodeTagLine: "Kanzu or Smart Casual",
  },
  mehndi: {
    id: "07978449-d226-4ac7-8286-6caea4523825",
    content: [
      { text: "ABBAS, ALI & FATEMAH MERCHANT ", className: "mainhead" },
      {
        text: " Invite you to join them for a joyous evening of",
        className: "headingText4",
      },
    ],
    //dressCodeTagLine: "Gents: Kurta Pajama or Shalwar Kameez",
  },
  nikkah: {
    id: "30523bb1-6ceb-428e-a802-9d42149011c6",
    content: [
      { text: "THE FAMILIES OF", className: "headingText5" },
      { text: "LATE ALI ZAFAR & RIAZ FATIMA JAFRI", className: "mainhead" },
      {
        text: "ZAHEER ALAM & SHAMA ZEHRA JAFRI",
        className: "mainhead",
      },
      { text: "TOGETHER WITH", className: "headingText4" },
      { text: "LATE ASHIQ ALI & MASOOMA JAFFERI", className: "mainhead" },
      {
        text: "LATE MUMTAZ ALI & LATE KANEEZ FATIMA",
        className: "mainhead",
      },
      {
        text: " CORDIALLY INVITE YOU TO",
        className: "headingText4",
      },
    ],
    // dressCodeTagLine: "Semi-Formal",
  },
  reception: {
    id: "2816e107-7da3-4c25-b701-b4b1b5de2a27",
    content: [
      { text: "THE SUNDERJI AND MERCHANT FAMILIES", className: "mainhead" },
      {
        text: "REQUEST YOUR GRACIOUS PRESENCE AT THE",
        className: "headingText4",
      },
    ],
    // dressCodeTagLine: "Formal",
  },
  shower: {
    id: "a1e18662-1fde-4d42-93ef-f04335df8e9b",
    content: [
      { text: "She’s tying the Knot", className: "mainhead" },
      {
        text: "Bridal Shower honoring Eshaal",
        className: "headingText4",
      },
    ],
  },
  "Family Dinner": {
    id: "4d42ca66-ce6e-4dbb-9463-0ee3aa090215",
    content: [
      { text: "MOHAMED AND ATIYA SUNDERJI", className: "mainhead" },
      {
        text: "REQUEST YOUR GRACIOUS PRESENCE AT THE",
        className: "headingText4",
      },
    ],
    // dressCodeTagLine: "Formal",
  },
  "Kabrastan Majlis": {
    id: "c0e84e83-b9ba-4dc1-8844-0d09d2ee99da",
    content: [
      { text: "MOHAMED & ATIYA SUNDERJI", className: "mainhead" },
      {
        text: "invite you to join them for the",
        className: "headingText4",
      },
      { text: "Kabrastan Majlis", className: "mainhead" },
      {
        text: "For the Ithale Thawab",
        className: "headingText4",
      },
      {
        text: "of all our Marhumeen",
        className: "headingText4",
      },
    ],
  },
};

const checkPath = (str, navigate) => {
  if (typeof str !== "string") {
    navigate("/");
    return false;
  }
  return true;
};

const RSVPValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),

  lastName: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),

  phoneNumber: Yup.string()
    .required("Required"),

  email: Yup.string().email("Invalid email").required("Required"),

  gents: Yup.number().min(0, "Must be at least 0"),

  ladies: Yup.number().min(0, "Must be at least 0"),

  children: Yup.number()
    .min(0, "Must be at least 0")
    .max(10, "Must be at most 10"),
});

const Rsvp = () => {
  const navigate = useNavigate();
  const [isAccepted, setIsAccepted] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorForDropdown, setErrorForDropdown] = useState(true)

  const path = useParams();
  const location = useLocation();
  const eventName = location.pathname.split("/");

  let currentEvent = "";

  // const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate("/");
  };

  const gentsReceived = checkPath(location.pathname.split("/")[2], navigate);
  const ladiesReceived = checkPath(location.pathname.split("/")[3], navigate);
  const childrenReceived = checkPath(location.pathname.split("/")[4], navigate);

  const allowGents = gentsReceived
    ? +location.pathname.split("/")[2]?.charCodeAt(0) - 96
    : 0;
  const allowLadies = ladiesReceived
    ? +location.pathname.split("/")[3]?.charCodeAt(0) - 96
    : 0;
  const allowChildren = childrenReceived
    ? +location.pathname.split("/")[4]?.charCodeAt(0) - 96
    : 0;

  if (eventName[1].includes("milad")) {
    currentEvent = events.milad;
  } else if (eventName[1].includes("welcome")) {
    currentEvent = events.welcome;
  } else if (eventName[1].includes("mehndi")) {
    currentEvent = events.mehndi;
  } else if (eventName[1].includes("nikkah")) {
    currentEvent = events.nikkah;
  } else if (eventName[1].includes("reception")) {
    currentEvent = events.reception;
  } else if (eventName[1].includes("shower")) {
    currentEvent = events.shower;
  } else if (eventName[1].includes("dinner")) {
    currentEvent = events["Family Dinner"];
  } else if (eventName[1].includes("majlis")) {
    currentEvent = events["Kabrastan Majlis"];
  }
  const { useGetQuery, usePostMutation } = useApi();
  const {
    data,
    isFetching,
    refetch: FetchCallsDetailsData,
  } = useGetQuery(["get-event"], API_ENDPOINTS.GET_EVENT + currentEvent.id);
  const { mutate: checkUserExists } = usePostMutation(
    API_ENDPOINTS.CHECK_USER_EXISTS
  );
  const { mutate: postUserInfo } = usePostMutation(API_ENDPOINTS.STORE_USER);

  const formSubmitHandler = (values) => {
    if(errorForDropdown) {
      return
    }
    setIsLoading(true);

    // Defaulting to 0 if fields are empty
    values.gents = values.gents || 0;
    values.ladies = values.ladies || 0;
    values.children = values.children || 0;
  
    // Collecting attendee names for gents, ladies, and children
    const gentsAttendees = Array.from({ length: values.gents }).map((_, i) => ({
      name: values[`gent-${i}`] || "",
    }));
    const ladiesAttendees = Array.from({ length: values.ladies }).map((_, i) => ({
      name: values[`lady-${i}`] || "",
    }));
    const childrenAttendees = Array.from({ length: values.children }).map((_, i) => ({
      name: values[`child-${i}`] || "",
    }));
    postUserInfo(
      {
        event_uuid: currentEvent?.id,
        rsvp_status: isAccepted ? "Accepted" : "Declined",
        first_name: values.firstName,
        last_name: values.lastName,
        phone: values.phoneNumber,
        email: values.email,
        gents: values.gents ,
        ladies: values.ladies,
        children: values.children,
        gents_attendees: gentsAttendees,
        ladies_attendees: ladiesAttendees,
        children_attendees: childrenAttendees,
      },
      {
        onSuccess: (response) => {
          setIsLoading(false);
          CustomToast("success", response.message || "User Updated");
          navigate("/", { state: response.data });
          // FetchCommentsData();
        },
        onError: (error) => {
          setIsLoading(false);
          CustomToast(
            "error",
            error?.response?.data?.message || "Updation Failed"
          );
        },
      }
    );
  };
  return (
    <div
      className="bigbg"
      style={{
        backgroundImage: `url(${newbg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        height: "auto"
      }}
    >
      <div className="flex justify-center mt-2">
        <div onClick={handleLogoClick} className="cursor-pointer">
          <img src={logo} alt="Logo" className="top-logo" />
        </div>
      </div>
      <div className="flex justify-center items-center">
        <div className="sub-cont pb-12">
          {currentEvent?.content?.map((line, index) => {
            return (
              <p
                className={`text-[20px] text-center font-[bold] text-[#4F2532] ${line.className}`}
              >
                {line.text}
              </p>
            );
          })}
          <div>
            {!isFetching ? (
              <RSVPCardData data={data} className="w-[100%]" />
            ) : (
              <LoaderModal />
            )}
          </div>

          {isLoading && <LoaderModal />}

          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              phoneNumber: "",
              email: "",
              gents: "",
              ladies: "",
              children: "",
            }}
            validationSchema={RSVPValidationSchema}
            onSubmit={(values) => {
              formSubmitHandler(values);
            }}
          >
            {({ errors, touched, values, setFieldValue  }) => {
              const handleAttendeeChange = (field, value) => {
                setFieldValue(field, Number(value));
                setErrorForDropdown(false)
              };
              return (<Form className="form-grp mb-6">
                <div className="flex justify-between flex-col gap-4">
                  <div className="">
                    <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-2 gap-4 two-fields">
                      <div className="pt-5">
                        <Field
                          name="firstName"
                          placeholder="First Name"
                          component={InputField}
                        />
                      </div>

                      <div className="pt-5">
                        <Field
                          name="lastName"
                          placeholder="Last Name"
                          component={InputField}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-4 w-full">
                    <div className="">
                      <Field
                        name="phoneNumber"
                        placeholder="Phone Number"
                        component={InputField}
                      />
                    </div>

                    <div className="">
                      <Field
                        name="email"
                        placeholder="Email Address"
                        component={InputField}
                      />
                    </div>
                  </div>
                </div>
                <div className="pt-[14px]">
                  <h1
                    className="text-[14px] text-[#4F2532]"
                    style={{ fontFamily: "bold" }}
                  >
                    Number Of Attendees
                  </h1>

                  <div className="grid grid-cols-1 two-fields mt-[0.5rem] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
                    {allowGents > 0 && (
                      <div className="flex flex-col gap-3">
                        <Field
                          name="gents"
                          placeholder="Gents"
                          component={Dropdown}
                          errorForDropdown={errorForDropdown}
                          onChange={(e) => handleAttendeeChange("gents", e.target.value)}
                          options={new Array(Math.min(allowGents + 1, 6))
                            .fill(0)
                            .map((a, i) => ({
                              value: i,
                              label:
                                i === 0
                                  ? "No one"
                                  : `${i} person${i > 1 ? "s" : ""}`,
                            }))}
                          type="number"
                        />
                        {[...Array(Number(values.gents))].map((_, index) => (
                          <Field
                            key={`gent-${index}`}
                            name={`gent-${index}`}
                            placeholder={`Gent ${index + 1} Name`}
                            component={InputField}
                          />
                        ))}
                      </div>
                    )}

                    {allowLadies > 0 && (
                      <div className="flex flex-col gap-3">
                        <Field
                          name="ladies"
                          placeholder="Ladies"
                          component={Dropdown}
                          errorForDropdown={errorForDropdown}
                          onChange={(e) => handleAttendeeChange("ladies", e.target.value)}
                          options={new Array(Math.min(allowLadies + 1, 6))
                            .fill(0)
                            .map((a, i) => ({
                              value: i,
                              label:
                                i === 0
                                  ? "No one"
                                  : `${i} person${i > 1 ? "s" : ""}`,
                            }))}
                          type="number"
                        />
                        {[...Array(Number(values.ladies))].map((_, index) => (
                          <Field
                            key={`lady-${index}`}
                            name={`lady-${index}`}
                            placeholder={`Lady ${index + 1} Name`}
                            component={InputField}
                          />
                        ))}
                      </div>
                    )}
                    {allowChildren > 0 && (
                      <div className="flex flex-col gap-3">
                        <Field
                          name="children"
                          placeholder="Children < 6"
                          component={Dropdown}
                          type="number"
                          min="0"
                          errorForDropdown={errorForDropdown}
                          onChange={(e) => handleAttendeeChange("children", e.target.value)}
                          options={new Array(Math.min(allowChildren + 1, 6))
                            .fill(0)
                            .map((a, i) => ({
                              value: i,
                              label:
                                i === 0
                                  ? "No one"
                                  : `${i} person${i > 1 ? "s" : ""}`,
                            }))}
                          onKeyDown={(e) => {
                            if (e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                        />
                        {[...Array(Number(values.children))].map((_, index) => (
                          <Field
                            key={`child-${index}`}
                            name={`child-${index}`}
                            placeholder={`Child ${index + 1} Name`}
                            component={InputField}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <div className="">
                  <br></br>
                  {data?.data?.attire && data?.data?.attire?.length > 0 && (
                    <h1
                      className="text-[14px] text-[#4F2532]"
                      style={{ fontFamily: "bold" }}
                    >
                      {" "}
                      DRESS CODE:{" "}
                    </h1>
                  )}
                  {data?.data?.attire && data?.data?.attire?.length > 0 && (
                    <h1 className="headingText3">
                      {currentEvent.dressCodeTagLine}
                    </h1>
                  )}
                  {data?.data?.attire && (
                    <h1
                      className="headingText4"
                      dangerouslySetInnerHTML={{ __html: data?.data?.attire }}
                    />
                  )}{" "}
                  <div className="grid grid-cols-1  mt-10 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-4">
                    <div>
                      <Reusablebutton
                        className="!bg-[none] text-[13px] w-full text-[#4F2532] rounded-[18px] border border-[#4F2532]"
                        style={{ fontFamily: "bold" }}
                        buttonLabel="Decline"
                        onClick={(e) => {
                          setIsAccepted(false);
                        }}
                      />
                    </div>
                    <div>
                      <Reusablebutton
                        className="bg-[#EFB6B6] text-[13px] text-[#4F2532] rounded-[18px] w-full"
                        buttonLabel="Accept"
                        type="submit"
                        onClick={(e) => {
                          setIsAccepted(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Form>)
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Rsvp;
